export const expressionHeaderText = "aCa";
export const userVoiceIdeasPaneHeader = "bCa";
export default {expressionHeaderText,userVoiceIdeasPaneHeader};